import { useParams } from "react-router-dom";
import { cuesApi } from "./imports";

import CueEditCrop from "./shared/CueEditCrop";

export default function CueEditCropWrapper({ cue }) {
	const { projectId } = useParams();

	const handleOnUpdate = (update) => {
		cuesApi.updateCue(cue.id, projectId, update);
	};

	return <CueEditCrop cue={cue} onUpdate={handleOnUpdate} />;
}
